<script>
  let name = "Jane Doe",
    email = "jane.doe@raid.gg",
    title = "Meme Churner",
    pronouns = "She/They";

  function copyContent() {
    var r = document.createRange();
    r.selectNode(document.getElementById("signature"));

    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
  />
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link
    href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,500;1,600&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<main>
  <div class="container col-lg-5">
    <h4>RAID Email Signature</h4>
    <a
      href="https://support.google.com/a/users/answer/9259758?hl=en"
      target="_blank">How to set your signature</a
    >
    <div class="row mt-3 mb-3">
      <div class="col-lg">
        <input
          type="text"
          class="form-control"
          placeholder="Name"
          aria-label="Name"
          bind:value={name}
        />
      </div>
      <div class="col">
        <input
          type="text"
          class="form-control"
          placeholder="Job Title"
          aria-label="Job Title"
          bind:value={title}
        />
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-lg">
        <input
          type="text"
          class="form-control"
          placeholder="Pronouns"
          aria-label="Pronouns"
          bind:value={pronouns}
        />
      </div>
      <div class="col">
        <input
          type="email"
          class="form-control"
          placeholder="email"
          aria-label="email"
          bind:value={email}
        />
      </div>
    </div>
    <table id="signature" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <td
            ><div>
              <img
                src="/raid_logo.png"
                alt="RAID Studios Logo"
                style="height:120px;"
              />
            </div></td
          >
          <td>
            <div style="margin: 0 auto;height: 120px;text-align: center;">
              <img
                src="/raid_line.png"
                alt="Separator"
                style="height:120px; padding: 0px 18px;"
              />
            </div>
          </td>
          <td>
            <table
              style="font-family: 'Roboto', sans-serif;font-weight: 500;color: #212121;"
              cellspacing="0"
              cellpadding="0"
            >
              <tbody>
                <tr
                  ><h4
                    style="font-size: 12pt;font-weight: 600;line-height: 20px; margin: 0;"
                  >
                    {name}
                  </h4></tr
                >
                <tr
                  ><p style="font-size: 11pt; line-height: 18px; margin: 0;">
                    {title}
                  </p></tr
                >
                <tr
                  ><p style="font-size: 9pt; line-height: 16px; margin: 0;">
                    {pronouns}
                  </p></tr
                >
                <tr><br style="margin-top: 8px" /></tr>
                <tr
                  ><a
                    href="https://raid.gg"
                    target="_blank"
                    style="text-decoration: unset!important;"
                    ><h4
                      style="font-size: 12pt;font-weight: 600;color: #4f2b88;line-height: 10px;vertical-align: bottom; margin: 0px;text-decoration: unset!important;"
                    >
                      RAID Studios
                    </h4></a
                  ></tr
                >
                <tr
                  ><a
                    href="mailto:{email}"
                    style="font-size: 10pt;color: #212121;text-decoration: unset!important; margin: 0;"
                    >{email}</a
                  ></tr
                >
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-primary mt-5" on:click={copyContent}
      >Copy Signature</button
    >
  </div>
</main>

<style>
</style>
